import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import { useAddNotification } from "hooks";
import { renderConditionalProp } from "../../../../../utility/utils";

import { useRequest } from "../../../../../hooks/useRequest";
import { useAssets } from "../../../../../hooks/useAssets";
import * as requestUrl from "../../../../../constants/request";

import classes from "./Final.module.scss";

export const Final = () => {
  const { t } = useTranslation(["account", "common"]);
  const [mailSent, setMailSent] = useState(false);
  const { createAssetUrl } = useAssets();

  const [searchParams] = useSearchParams();
  const { request } = useRequest();
  const addNotification = useAddNotification();

  const resendEmailHandler = () => {
    const sessionToken = searchParams.get("session_token") || "";
    if (!!sessionToken) {
      request(requestUrl.FT_USERS_VERIFICATION, {
        data: sessionToken,
        headers: {
          "content-type": "text/plain",
        },
        method: "POST",
      })
        .then((response: any) => {
          setMailSent(true);
          addNotification({
            messages: ["email_sent"],
            type: "SUCCESS",
            closable: true,
          });
        })
        .catch((err) => {
          addNotification({
            messages: ["something_went_wrong"],
            type: "ERROR",
            closable: true,
          });
        });
    }
  };

  const loginHandler = () => {
    const state = searchParams.get("state");

    if (state) {
      const uri = new URL(
        `https://${import.meta.env.REACT_APP_AUTH0_DOMAIN}/continue`,
      );
      uri.searchParams.append("state", state);
      window.location.assign(uri.toString());
    }
  };

  return (
    <div className={classes.Container}>
      <div className={classes.Main}>
        <p className={classes.Heading}>{t("common:congratulations")}</p>
        <p className={classes.Heading1}>{t("account:account_created")}</p>
        <p className={classes.Detail}>{t("account:account_creation_text")}</p>
        <p className={classes.Detail}>
          {t("account:account_verification_text")}
        </p>
        <div className={classes.Buttons}>
          <ft-button
            onClick={resendEmailHandler}
            {...renderConditionalProp(mailSent, "disabled")}
            class={[classes.Back, "outline-button"].join(" ")}
            outlined
            label={t("account:resend_email")}
          ></ft-button>
          <ft-button
            onClick={loginHandler}
            unelevated
            label={t("common:login")}
          ></ft-button>
        </div>
      </div>
      <div className={classes.Image_container}>
        <img alt="confirmation" src={createAssetUrl("successful-action")}></img>
      </div>
    </div>
  );
};
